import React from 'react';
import {connect} from 'react-redux';
import {lang} from './dictionary';
import './share.css';

const AKADEMIA_URL = 'https://akademia.uczymydzieciprogramowac.pl/pl/wirtualna-mata-do-kodowania';

class Share extends React.Component {
    setHref(e) {
        const split = document.location.href.split('/');
        const hash = split[split.length - 1];
        let url = AKADEMIA_URL;
        url = url.split('/');
        let index = url.length;
        if (e.target.id.includes('PDF')) {
            url.splice(index, 0, 'pdf');
        }
        else url.splice(index, 0, 'img');
        url.push(hash);
        const win = window.open(url.join('/'), '_blank');
        win.focus();
    }

    copyToClipboard() {
        let copyText = document.getElementById("inputLink");
        copyText.select();
        document.execCommand("copy");

        let tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = lang['skopiowane'][this.props.language]
    }

    outFunc() {
        let tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = lang['kopiuj'][this.props.language];
    }

    selectAll(e) {
        e.target.select();
    }

    render() {
        let url = document.location.href;
        return (
            <div>
                <div className={'mt-3'}>
                    <h5>{lang['link-do-twojej-maty'][this.props.language]}</h5>
                    <div id="tooltip" className={'w-100'}>
                        <input onFocus={this.selectAll} type="text" value={this.props.mataUrl} id="inputLink" readOnly/>
                        <button id="copyBtn" onClick={this.copyToClipboard.bind(this)}
                                onMouseOut={this.outFunc.bind(this)}>
                            Kopiuj
                        </button>
                        <span id="copyTooltip">{lang['kopiuj'][this.props.language]}</span>
                    </div>
                </div>
                <div className="fb-share-button mt-3" data-href={url}
                     data-layout="button" data-size="large" data-mobile-iframe="false">
                    <a target="_blank"
                       rel="noopener noreferrer"
                       href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
                       className="fb-xfbml-parse-ignore">Share</a>
                </div>
                <div className="text-center mt-3 d-flex flex-column justify-content-between">
                    <span id="savePDF"  onClick={this.setHref}>Pobierz matę jako PDF</span>
                    <span id="saveJPG" className="mt-1"  onClick={this.setHref}>Pobierz matę jako obrazek</span>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        language: state.language,
        mataUrl: state.mataUrl
    })
)(Share)



// WEBPACK FOOTER //
// ./src/Share.js